import axios from 'axios';
import { getVuexPeristence } from '../';

axios.interceptors.response.use((response) => { // intercept the global error
    return response;
}, function (error) {
    if (error.response.status === 401) {
        window.location.href = '/login';
        return;
    }
    return Promise.reject(error);
});

export default {
    namespaced: true,
    state: {
        mode: '',
        currentExperienceToken: '',
        currentOrganisationToken: '',
        experiences: [],
        defaultNewExperience: {
            name: '',
            description: ''
        },
        newExperience: {},
        selectSortDescription: getVuexPeristence('experiences.selectSortDescription',
            'Tri par date de mise à jour'),
        orderSort: getVuexPeristence('experiences.orderSort', false)
    },
    getters: {
        mode: (state) => {
            return state.mode;
        },
        currentExperienceToken: (state) => {
            return state.currentExperienceToken;
        },
        currentOrganisationToken: (state) => {
            return state.currentOrganisationToken;
        },
        experiences: (state) => {
            return state.experiences;
        }
    },
    mutations: {
        SET_MODE_EXPERIENCE: (state, data) => {
            state.mode = data.mode;
            state.currentExperienceToken = data.experienceToken;
            state.currentOrganisationToken = data.organisationToken;
            state.newExperience = state.defaultNewExperience;
        },
        DELETE_EXPERIENCE_IN_STORE: (state) => {
            state.experiences = state.experiences.filter((experience) => {
                return experience.token !== state.currentExperienceToken;
            });
        },
        SET_EXPERIENCE_LIST: (state, { list }) => {
            state.experiences = list;
        },
        ADD_EXPERIENCE_IN_STORE: (state, experience) => {
            state.experiences.push(experience);
            state.newExperience = state.defaultNewExperience;
        },
        SET_NEW_EXPERIENCE: (state, data) => {
            state.newExperience = Object.assign({}, state.newExperience, data);
        },
        SET_SELECT_SORT_DESCRIPTION: (state, data) => {
            state.selectSortDescription = data;
        },
        SET_ORDER_SORT: (state, data) => {
            state.orderSort = data;
        }
    },
    actions: {
        modeNewExperience: (localStore) => {
            localStore.commit('SET_MODE_EXPERIENCE', {
                mode: 'add',
                experienceToken: '',
                organisationToken: ''
            });
        },
        modeDeleteExperience: (localStore, data) => {
            localStore.commit('SET_MODE_EXPERIENCE', {
                mode: 'delete',
                experienceToken: data.experienceToken,
                organisationToken: data.organisationToken
            });
        },
        modeTestExperience: (localStore, data) => {
            localStore.commit('SET_MODE_EXPERIENCE', {
                mode: 'test',
                experienceToken: data.experienceToken,
                organisationToken: data.organisationToken
            });
        },
        modeResetExperience: (localStore) => {
            localStore.commit('SET_MODE_EXPERIENCE', {
                mode: '',
                experienceToken: '',
                organisationToken: ''
            });
        },
        deleteExperience: (localStore) => {
            return new Promise((resolve, reject) => {
                axios.delete('/campaign/' + localStore.state.currentExperienceToken,
                    { data: { '_ids': localStore.state.currentExperienceToken } })
                    .then(() => {
                        localStore.commit('DELETE_EXPERIENCE_IN_STORE');
                        resolve();
                    }).catch((err) => reject(err));
            });
        },
        addExperience: (localStore) => {
            return new Promise(function (resolve, reject) {
                axios.post('/campaign', localStore.state.newExperience).then((response) => {
                    localStore.commit('ADD_EXPERIENCE_IN_STORE', response.data.campaign);
                    resolve(response.data.campaign.token);
                }, (err) => {
                    reject(err);
                });
            });
        },
        loadExperiences: (localStore) => {
            return new Promise((resolve, reject) => {
                axios.get('/campaign').then((response) => {
                    localStore.commit('SET_EXPERIENCE_LIST', { list: response.data.campaigns });
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        }
    }
};
